import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";

import { ManageService } from "../services/Services";
import useStore from "../services/store/useStore";

export const useGetCryptoCoins = platform => {
    const { setCoins } = useStore(state => state);

    const [isLoadingCoins, setIsLoadingCoins] = useState(false);

    const getCoins = useCallback(async () => {
        setIsLoadingCoins(true);
        try {
            const coins = await ManageService.getCryptoCoins(platform);
            if (coins && coins.length) {
                setCoins(coins);
            }
        } catch (error) {
            console.log("error al intentar obtener las monedas crypto disponibles");
            toast.error(error.message);
        } finally {
            setIsLoadingCoins(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        getCoins();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { isLoadingCoins };
};
